import { act } from "react-dom/test-utils"
import { Database, DatabaseItemsEntry, DatabaseManufacturer, DatabaseOwnerEntry, DatabaseProduct } from "./Database"
import { generateRandomString } from "./random"

export interface apiInterface {
    raw(action: apiAction, params?: apiParams): Promise<any>
    get(action: apiAction, params?: apiParams): Promise<any>
    post(action: apiAction, data?: any, params?: apiParams): Promise<any>
    put(action: apiAction, data?: any, params?: apiParams): Promise<any>
    delete(action: apiAction, data?: any, params?: apiParams): Promise<any>

    isFake(): boolean
}

export interface apiParams {
    [id: string]: string
}

export function encodeapiParams(params: apiParams): string {
    //console.log(Object.keys(params).map((id) => id + "=" + encodeURI(params[id])).join("&"))
    return Object.keys(params).map((id) => id + "=" + encodeURI(params[id])).join("&")
}

export function mustGetIdFromApiParams(id: string, params?: apiParams): string {
    if(params) {
        if(params[id]) {
            return params[id];
        }
        throw new Error("no such value in apiParams: " + id);
    }
    throw new Error("undefined params");
}

export enum apiAction {
    // Owner API's
    REGISTER_OWNER = "owners",
    GET_OWNERS = "owners",
    GET_OWNER = "owners/:ownerId",
    UPDATE_OWNER = "owners/:ownerId",
    DELETE_OWNER = "owners/:ownerId",
    // PRODUCT API's
    REGISTER_MANUFACTURER = "manufacturers",
    GET_MANUFACTURERS = "manufacturers",
    GET_MANUFACTURER = "manufacturers/:manufacturerId",
    UPDATE_MANUFACTURER = "manufacturers/:manufacturerId",
    DELETE_MANUFACTURER = "manufacturers/:manufacturerId",
    // Product API's
    REGISTER_PRODUCT = "products",
    GET_PRODUCTS = "products",
    GET_PRODUCT = "products/:productId",
    UPDATE_PRODUCT = "products/:productId",
    DELETE_PRODUCT = "products/:productId",
    // VARIANTS 
    GET_VARIANTS = "products/:productId/variants",
    EDIT_ORDER_VARIANTS = "order_variants",
    // DPP API's
    REGISTER_ITEM = "dpp",
    GET_DPP = "dpp/list",
    GET_ITEM = "dpp",
}

export class urlApi {
    url: string

    constructor(url: string) {
        this.url = url;
    }

    isFake(): boolean {
        return false;
    }

    prepareUrl(action: apiAction, params?: apiParams): string {
        return this.url + "/" + action.split("/").map(val => {
            if(val.startsWith(":")) {
                const id = val.substring(1)
                if(params && params[id]) {
                    const out = params[id];
                    delete params[id]
                    if(Object.keys(params).length === 0) {
                        params = undefined
                    }
                    return out
                }
            }
            return val
        }).join("/") + ((params) ? "?" + encodeapiParams(params) : "");
    }

    get(action: apiAction, params?: apiParams): Promise<any> {
        return fetch(this.prepareUrl(action, params)).then(async (val) => {
            const body = await val.text();
            if(!val.ok) {
                throw {
                    body: body,
                    status: val.status,
                    statusText: val.statusText,
                };
            }
            return JSON.parse(body);
        });
    }

    raw(action: apiAction, params?: apiParams): Promise<any> {
        return fetch(this.prepareUrl(action, params)).then(async (val) => {
            const body = await val.blob();
            if(!val.ok) {
                throw {
                    body: body,
                    status: val.status,
                    statusText: val.statusText,
                };
            }
            return body;
        });
    }

    do(method: string, action: apiAction, data?: any, params?: apiParams): Promise<any> {
        return fetch(this.prepareUrl(action, params), {
            body: (data) ? JSON.stringify(data): undefined,
            method: method,
        }).then(async val => {
            const body = await val.text();
            if(!val.ok) {
                throw JSON.parse(body).error;
            }
            return JSON.parse(body);
        })
    }

    post(action: apiAction, data?: any, params?: apiParams): Promise<any> {
        return this.do("POST", action, data, params)
    }
    put(action: apiAction, data?: any, params?: apiParams): Promise<any> {
        return this.do("PUT", action, data, params)
    }
    delete(action: apiAction, data?: any, params?: apiParams): Promise<any> {
        return this.do("DELETE", action, data, params)
    }
}


export class databaseApi {
    db: Database
    timeout?: number

    constructor(db: Database, timeout?: number) {
        this.db = db;
        this.timeout = timeout;
    }

    isFake(): boolean {
        return true;
    }

    preparePromise(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(data);
            }, this.timeout)
        })
    }

    raw(action: apiAction, params?: apiParams): Promise<any> {
        switch (action) {
            case apiAction.GET_DPP:
                // todo
                return this.preparePromise("https://test-dpp.mynext.id/product/gy6782")
            case apiAction.GET_MANUFACTURER:
                const manufacturerId = mustGetIdFromApiParams("manufacturerId", params);
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].manufacturers?.find((val) => {
                    return val.id === manufacturerId
                }));
                case apiAction.GET_MANUFACTURERS:
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].manufacturers);
            case apiAction.GET_OWNER:
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].owner);
            case apiAction.GET_OWNERS:
                return this.preparePromise(Object.keys(this.db).map(id => this.db[id].owner));
            case apiAction.GET_PRODUCT:
                const productId = mustGetIdFromApiParams("productId", params);
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].products?.find((val) => {
                    return val.id === productId
                }));
            case apiAction.GET_PRODUCTS:
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].products);
            default:
                throw new Error("cannot use action " + action + " in get request")
        }
    }

    get(action: apiAction, params?: apiParams): Promise<any> {
        switch (action) {
            case apiAction.GET_DPP:

                // todo
                return this.preparePromise("https://test-dpp.mynext.id/product/gy6782")
            case apiAction.GET_MANUFACTURER:
                const manufacturerId = mustGetIdFromApiParams("manufacturerId", params);
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].manufacturers?.find((val) => {
                    return val.id === manufacturerId
                }));
                case apiAction.GET_MANUFACTURERS:
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].manufacturers);
            case apiAction.GET_OWNER:
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].owner);
            case apiAction.GET_OWNERS:
                return this.preparePromise(Object.keys(this.db).map(id => this.db[id].owner));
            case apiAction.GET_PRODUCT:
                const productId = mustGetIdFromApiParams("productId", params);
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].products?.find((val) => {
                    return val.id === productId
                }));
            case apiAction.GET_PRODUCTS:
                return this.preparePromise(this.db[mustGetIdFromApiParams("ownerId", params)].products);
            default:
                throw new Error("cannot use action " + action + " in get request")
        }
    }

    post(action: apiAction, data?: any, params?: apiParams): Promise<any> {
        switch (action) {
            case apiAction.REGISTER_ITEM:
                if(data) {
                    if(data as DatabaseItemsEntry) {
                        let owner = this.db[mustGetIdFromApiParams("ownerId", params)];
                        const item = data as DatabaseItemsEntry
                        const product = owner.products.find(product => {
                            return product.sap_product_code === item.sap_product_code
                        })
                        if(product && product.id) {
                            item.id = generateRandomString(12);
                            owner.items[product.id].push(item);
                            return this.preparePromise(item.id);
                        }
                        throw new Error("no such sap code")
                    }
                    throw new Error("incorrect body");
                }
                throw new Error("no body")
            case apiAction.REGISTER_OWNER:
                if(data) {
                    if(data as DatabaseOwnerEntry) {
                        const owner = data as DatabaseOwnerEntry;
                        owner.id = generateRandomString(12);
                        this.db[owner.id] = {
                            owner: owner,
                            products: [],
                            manufacturers: [],
                            items: {},
                        }
                        return this.preparePromise(owner.id);
                    }
                    throw new Error("incorrect body");
                }
                throw new Error("no body")
            case apiAction.REGISTER_MANUFACTURER:
                if(data) {
                    if(data as DatabaseManufacturer) {
                        let owner = this.db[mustGetIdFromApiParams("ownerId", params)];
                        const mnf = data as DatabaseManufacturer
                        mnf.owner_id = owner.owner.id;
                        mnf.id = generateRandomString(12);
                        owner.manufacturers.push(mnf);
                        return this.preparePromise(mnf.id);
                    }
                    throw new Error("incorrect body");
                }
                throw new Error("no body")
            case apiAction.REGISTER_PRODUCT:
                if(data) {
                    if(data as DatabaseProduct) {
                        let owner = this.db[mustGetIdFromApiParams("ownerId", params)];
                        const product = data as DatabaseProduct
                        product.owner_id = owner.owner.id;
                        product.id = generateRandomString(12);
                        owner.products.push(product);
                        owner.items[product.id] = [];
                        return this.preparePromise(product.id);
                    }
                    throw new Error("incorrect body");
                }
                throw new Error("no body")
            default:
                throw new Error("cannot use action " + action + " in post request")
        }
    }
    put(action: apiAction, data?: any, params?: apiParams): Promise<any> {
        switch (action) {
            case apiAction.UPDATE_MANUFACTURER:
                if(data) {
                    if(data as DatabaseProduct) {
                        let owner = this.db[mustGetIdFromApiParams("ownerId", params)];
                        const product = data as DatabaseManufacturer        
                        const productId = mustGetIdFromApiParams("manufacturerId", params);
                        return this.preparePromise((owner.manufacturers.find((val, index) => {
                            if (val.id === productId) {
                                owner.manufacturers[index] = {...product, id: val.id, owner_id: val.owner_id}
                                return true;
                            }
                            return false;
                        })) ? true : false);
                    }
                    throw new Error("incorrect body");
                }
                throw new Error("no body")
            case apiAction.UPDATE_OWNER:
                if(data) {
                    if(data as DatabaseOwnerEntry) {
                        let owner = this.db[mustGetIdFromApiParams("ownerId", params)];
                        const newOwnerData = data as DatabaseOwnerEntry        
                        owner.owner = {...newOwnerData, id: owner.owner.id}
                        return this.preparePromise(true)
                    }
                    throw new Error("incorrect body");
                }
                throw new Error("no body")
            case apiAction.UPDATE_PRODUCT:
                if(data) {
                    if(data as DatabaseProduct) {
                        let owner = this.db[mustGetIdFromApiParams("ownerId", params)];
                        const product = data as DatabaseProduct        
                        const productId = mustGetIdFromApiParams("productId", params);
                        return this.preparePromise((owner.products.find((val, index) => {
                            if (val.id === productId) {
                                owner.products[index] = {...product, id: val.id, owner_id: val.owner_id}
                                return true;
                            }
                            return false;
                        })) ? true : false);
                    }
                    throw new Error("incorrect body");
                }
                throw new Error("no body")
            default:
                throw new Error("cannot use action " + action + " in put request")
        }
    }
    delete(action: apiAction, data?: any, params?: apiParams): Promise<any> {
        const owner = this.db[mustGetIdFromApiParams("ownerId", params)];
        let wasDeleted = false;
        switch (action) {
            case apiAction.DELETE_MANUFACTURER:
                const manufacturerId = mustGetIdFromApiParams("manufacturerId", params);
                owner.manufacturers = owner.manufacturers.filter(m => {
                    if(m.id === manufacturerId) {
                        wasDeleted = true;
                    }
                    return m.id !== manufacturerId
                })
                return this.preparePromise(wasDeleted);
            case apiAction.DELETE_OWNER:
                delete this.db[mustGetIdFromApiParams("ownerId", params)];
                return this.preparePromise(true);
            case apiAction.DELETE_PRODUCT:
                const productId = mustGetIdFromApiParams("productId", params);
                owner.products = owner.products.filter(m => {
                    if(m.id === productId) {
                        wasDeleted = true;
                    }
                    return m.id !== productId
                })
                return this.preparePromise(wasDeleted);
            default:
                throw new Error("cannot use action " + action + " in delete request")
        }
    }
}